import {
    Box,
    Button,
    CloseButton,
    Dialog,
    Field,
    Flex,
    Grid,
    GridItem,
    Image,
    Input,
    InputGroup,
    Link,
    Stack,
    Text,
    VStack,
} from "@chakra-ui/react";
import { useRouter } from "next/router";
import { useState } from "react";

import { Checkbox } from "@/components/ui/checkbox";
import { toaster } from "@/components/ui/toaster";
import { usePostFormMutation } from "@/hooks/microservicesApi";

import PopupCita from "./popupCita";
import PopupCitaGuiaRent from "./popupCitaGuiaRent";

const ActionLinkContact = ({ children, icon, href, ...props }) => {
    return (
        <Link
            fontSize="xs"
            mb={2}
            href={href}
            placeSelf="center"
            justifyContent="center"
            {...props}
        >
            <Stack direction="row" align="center" placeSelf="center" justifyContent="center">
                <Image boxSize="25px" objectFit="cover" src={icon} alt={children} loading="lazy" />
            </Stack>
            <Stack direction="row" align="center" placeSelf="center" justifyContent="center">
                <Text fontWeight="400" fontSize="xs" mb={2} color="black" textAlign="center">
                    {children}
                </Text>
            </Stack>
        </Link>
    );
};

const CardCitaResponsive = ({
    urlBrochure,
    numeroAsesor,
    urlDev,
    tipo,
    id,
    hubspotForm,
    showBrouchure,
    nameAsesor,
}) => {
    const router = useRouter();

    const [nombre, setNombre] = useState("");
    const [apellidos, setApellidos] = useState("");
    const [telefono, setTelefono] = useState("");
    const [email, setEmail] = useState("");
    const esGuiaRent =
        router.pathname.includes("guiarent") || router.query["city-id"].includes("guiarent");
    const guiarentHubspotFormDirecta = "664b54d0-13c5-416a-a56c-9fa8ec4f5bfb";
    const guiarentHubspotFormCita = "80ad70a0-4734-4ce0-b54f-c3011726ad92";
    const [postForm] = usePostFormMutation();

    const [isOpen, setIsOpen] = useState(false);
    const [isRentOpen, setIsRentOpen] = useState(false);
    const [isCitaOpen, setIsCitaOpen] = useState(false);
    const [isPhoneOpen, setIsPhoneOpen] = useState(false);

    const onOpen = () => setIsOpen(true);
    const onClose = () => setIsOpen(false);

    const onRentOpen = () => setIsRentOpen(true);
    const onRentClose = () => setIsRentOpen(false);

    const onCitaOpen = () => setIsCitaOpen(true);
    const onCitaClose = () => setIsCitaOpen(false);

    const onPhoneOpen = () => setIsPhoneOpen(true);
    const onPhoneClose = () => setIsPhoneOpen(false);

    let date = "";
    let hour = "";

    const handleCitaClick = () => {
        if (esGuiaRent) {
            onCitaOpen();
        } else {
            onOpen();
        }
    };

    const handleSubmitPhone = (hbs_form) => {
        let data_send = esGuiaRent
            ? {
                  id: hbs_form,
                  body: {
                      fields: [
                          {
                              name: "firstname",
                              value: nombre,
                          },
                          {
                              name: "lastname",
                              value: apellidos,
                          },
                          {
                              name: "email",
                              value: email,
                          },
                          {
                              name: "phone",
                              value: telefono,
                          },
                          {
                              name: "asesor_opcionador_de_la_renta",
                              value: nameAsesor,
                          },
                      ],
                      context: {
                          ipAddress: "3.14.97.137",
                          pageUri: "www.grupoguia.mx",
                          pageName: "Grupo Guia | " + tipo + " " + id,
                      },
                  },
              }
            : {
                  id: hbs_form,
                  body: {
                      fields: [
                          {
                              name: "firstname",
                              value: nombre,
                          },
                          {
                              name: "lastname",
                              value: apellidos,
                          },
                          {
                              name: "email",
                              value: email,
                          },
                          {
                              name: "phone",
                              value: telefono,
                          },
                      ],
                      context: {
                          ipAddress: "3.14.97.137",
                          pageUri: "www.grupoguia.mx",
                          pageName: "Grupo Guia | " + tipo + " " + id,
                      },
                  },
              };
        if (hbs_form == "28a489aa-fa3c-45ff-bcd2-f7bf9a8004c8") {
            data_send.body.fields.push({
                name: "wiggot",
                value: id,
            });
        }
        postForm(data_send)
            .then(() => {
                window.open(
                    `https://api.whatsapp.com/send?phone=${numeroAsesor}&text=${`Hola mi nombre es ${nombre} ${apellidos}, me gustaría saber mas sobre una propiedad.`}`
                );
                setNombre("");
                setApellidos("");
                setEmail("");
                setTelefono("");
                onPhoneClose();
                toaster.create({
                    title: "¡Exito!",
                    description: "¡Tus datos fueron eviados correctamente!",
                    type: "success",
                    duration: 4000,
                    closable: true,
                });
                router.push(`/desarrollos/thankyoupage-contactar-whatsapp/${numeroAsesor}`);
            })
            .catch((error) => {
                console.error("Error: ", error);
            });
    };

    return (
        <>
            <PopupCita
                fecha={date}
                hora={hour}
                isOpen={isOpen}
                onClose={onClose}
                tipo={tipo}
                id={id}
                urlDev={urlDev}
                hubspotForm="11d898e2-b44c-42f4-9af0-8d3624f962e2"
            />
            <PopupCitaGuiaRent
                fecha={date}
                hora={hour}
                isRentOpen={isCitaOpen}
                onRentClose={onCitaClose}
                tipo={tipo}
                id={id}
                conCita={true}
                hubspotForm={guiarentHubspotFormCita}
            />
            <PopupCitaGuiaRent
                //fecha={date}
                //hora={hour}
                isRentOpen={isRentOpen}
                onRentClose={onRentClose}
                tipo={tipo}
                id={id}
                conCita={false}
                hubspotForm={guiarentHubspotFormDirecta}
            />
            <Dialog.Root
                open={isPhoneOpen}
                onOpenChange={() => onPhoneClose()}
                size="sm"
                placement="center"
            >
                <Dialog.Backdrop />
                <Dialog.Positioner>
                    <Dialog.Content>
                        <Dialog.CloseTrigger asChild>
                            <CloseButton />
                        </Dialog.CloseTrigger>
                        <Dialog.Body p={6} color="black">
                            <Stack py={6} px={4} borderBottomWidth="1px">
                                <Text fontWeight={700} fontSize="md" textAlign="left">
                                    {" "}
                                    ¡Completa tus datos y encuentra el lugar para ti!
                                </Text>
                                <Text fontWeight={400} fontSize="xs" color="accent.500">
                                    Te redigiremos a WhatsApp y enviamos un mensaje para que te
                                    contacte un asesor.
                                </Text>
                            </Stack>
                            <form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    handleSubmitPhone("28a489aa-fa3c-45ff-bcd2-f7bf9a8004c8");
                                }}
                            >
                                <Field.Root pt={6}>
                                    <Input
                                        rounded="full"
                                        placeholder="Nombre/s:"
                                        marginBottom="10px"
                                        id="nombres"
                                        type="text"
                                        value={nombre}
                                        required
                                        onChange={(e) => {
                                            e.preventDefault();
                                            setNombre(e.target.value);
                                        }}
                                        onBlur={(e) => {
                                            e.preventDefault();
                                            setNombre(e.target.value);
                                        }}
                                        px={4}
                                    />
                                </Field.Root>
                                <Field.Root>
                                    <Input
                                        rounded="full"
                                        placeholder="Apellidos:"
                                        marginBottom="10px"
                                        value={apellidos}
                                        id="apellidos"
                                        type="text"
                                        required
                                        onChange={(e) => {
                                            e.preventDefault();
                                            setApellidos(e.target.value);
                                        }}
                                        onBlur={(e) => {
                                            e.preventDefault();
                                            setApellidos(e.target.value);
                                        }}
                                        px={4}
                                    />
                                </Field.Root>
                                <Field.Root>
                                    <Input
                                        rounded="full"
                                        placeholder="Correo:"
                                        marginBottom="10px"
                                        value={email}
                                        id="email"
                                        type="email"
                                        required
                                        onChange={(e) => {
                                            e.preventDefault();
                                            setEmail(e.target.value);
                                        }}
                                        onBlur={(e) => {
                                            e.preventDefault();
                                            setEmail(e.target.value);
                                        }}
                                        px={4}
                                    />
                                </Field.Root>
                                <Field.Root>
                                    <InputGroup
                                        marginBottom="20px"
                                        borderLeftRadius="full"
                                        overflow="hidden"
                                        startAddon={
                                            <Flex
                                                gap={2}
                                                p={2}
                                                w="100%"
                                                h="100%"
                                                bg="#FFF"
                                                align="center"
                                                borderLeftRadius="full"
                                            >
                                                <Box backgroundColor="#FFFFFF" rounded="full">
                                                    <Image
                                                        src="https://media.grupoguia.mx/assets/home-page/icons/mexico.svg"
                                                        width="16px"
                                                        height="16px"
                                                        alt="mexico"
                                                    />
                                                </Box>
                                                <Box
                                                    backgroundColor="#FFFFFF"
                                                    borderLeftColor="#FFFFFF"
                                                    borderRadius="0px"
                                                    padding="0px"
                                                    paddingRight="10px"
                                                    color="#000"
                                                >
                                                    +52
                                                </Box>
                                            </Flex>
                                        }
                                    >
                                        <Input
                                            borderRadius="24px"
                                            placeholder="Teléfono:"
                                            type="number"
                                            id="telefono"
                                            value={telefono}
                                            required
                                            onChange={(e) => {
                                                e.preventDefault();
                                                setTelefono(e.target.value);
                                            }}
                                            onBlur={(e) => {
                                                e.preventDefault();
                                                setTelefono(e.target.value);
                                            }}
                                            px={4}
                                            pattern="[0-9]{10}"
                                            minLength={10}
                                        />
                                    </InputGroup>
                                </Field.Root>
                                <Button
                                    rounded="full"
                                    w="100%"
                                    fontWeight="500"
                                    color="black"
                                    bg="brand.500"
                                    borderColor="#FFCD00"
                                    _hover={{
                                        bg: "#EDBE00",
                                    }}
                                    type="submit"
                                >
                                    Enviar
                                </Button>
                                <VStack alignItems="center" mt="4">
                                    <Checkbox required size="sm" color="black" colorPalette="blue">
                                        He leído y acepto los{" "}
                                        <Link href="/terminosycondiciones">
                                            {" "}
                                            Términos y condiciones.
                                        </Link>
                                    </Checkbox>
                                </VStack>
                            </form>
                        </Dialog.Body>
                    </Dialog.Content>
                </Dialog.Positioner>
            </Dialog.Root>
            <Grid templateColumns={"repeat(" + (esGuiaRent ? 3 : 2) + ", 1fr)"} gap={2} h="24">
                <GridItem colSpan={1} alignSelf="center" justifyContent="center">
                    <ActionLinkContact
                        icon="https://media.grupoguia.mx/assets/home-page/fichas/Cita/calendario.webp"
                        idDisabled={false}
                        onClick={handleCitaClick}
                    >
                        {esGuiaRent ? "Agendar una cita" : "Quiero saber más"}
                    </ActionLinkContact>
                </GridItem>
                {esGuiaRent && (
                    <GridItem colSpan={1} alignSelf="center" justifyContent="center">
                        <ActionLinkContact
                            icon="https://media.grupoguia.mx/assets/home-page/fichas/amor.webp"
                            idDisabled={false}
                            onClick={() => {
                                onRentOpen();
                            }}
                        >
                            Rentar Sin Aval
                        </ActionLinkContact>
                    </GridItem>
                )}
                <GridItem colSpan={1} alignSelf="center" justifyContent="center">
                    <ActionLinkContact
                        icon="https://media.grupoguia.mx/assets/home-page/fichas/Cita/charla.webp"
                        idDisabled={false}
                        //onClick={() => {tipo==='Propiedad'?window.open("https://wa.me/"+numeroAsesor+"?text=Me interesa una  propiedad que comercializas."):window.open("tel:"+numeroAsesor)}}
                        onClick={() => {
                            onPhoneOpen();
                        }}
                    >
                        Contactar Asesor
                    </ActionLinkContact>
                </GridItem>
            </Grid>
        </>
    );
};

export default CardCitaResponsive;
